import { CategoryModalView } from '../../../javascripts/category_modal_mobile';

document.addEventListener('DOMContentLoaded', () => {
  const categorySearch = document.querySelector("#question-category-search");
  const statusSearch = document.querySelector("#question-status-search");

  if (categorySearch) new CategoryModalView(categorySearch);
  if (statusSearch) new CategoryModalView(statusSearch);

  document.querySelectorAll('.js-toggle-muted-post').forEach((toggleMuteBtn) => {
    toggleMuteBtn.addEventListener('click', () => {
      const post = toggleMuteBtn.closest('.js-post');
      const postContent = post.querySelector('.js-post-content');
      if (post.dataset.tmpUnmuted === 'false') {
        post.dataset.tmpUnmuted = 'true';
        postContent.classList.remove('hidden');
        toggleMuteBtn.innerText = '投稿を非表示';
      } else {
        post.dataset.tmpUnmuted = 'false';
        postContent.classList.add('hidden');
        toggleMuteBtn.innerText = '投稿を表示';
      }
    });
  });
});
